// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-image {
  display: block;
  width: 100%;
  height: 300px;
  object-fit: contain;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/component/productimage/productimage.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".product-image {\n  display: block;\n  width: 100%;\n  height: 300px;\n  object-fit: contain;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
